module.exports = __webpack_public_path__ + "static/2-44dd99e7871e20a76e44bc3d06570b14.png";